/**
 * Created by olga on 11.01.2023
 */

const SpecialEnergyOfferIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.special_energy_offer_json,
        skin: !cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "expedition" : "normal",
        priority: SideBar.PRIORITY_REDUNDANT
    });

    this.available = true;
    this.resetState();
};

SpecialEnergyOfferIcon.prototype = Object.create(SideBarIcon.prototype);
SpecialEnergyOfferIcon.prototype.constructor = SpecialEnergyOfferIcon;

SpecialEnergyOfferIcon.prototype.resetState = function () {
    if (!Merge2.current) {
        return;
    }

    const leftTime = cleverapps.specialEnergyOffer.getIconLeftTime();
    if (leftTime <= 0) {
        cleverapps.sideBar.removeTemporaryIcon(this);
    } else {
        this.setLeftTime(leftTime);
    }

    cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
};

SpecialEnergyOfferIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "SpecialEnergyOfferWindow",
        action: function (f) {
            new SpecialEnergyOfferWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};
